import React from 'react';

const FilledCheckmarkIcon = ({ width = 34, height = 34, color = '#000' }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.8333 0.5H4.16667C2.15 0.5 0.5 2.15 0.5 4.16667V29.8333C0.5 31.85 2.15 33.5 4.16667 33.5H29.8333C31.85 33.5 33.5 31.85 33.5 29.8333V4.16667C33.5 2.15 31.85 0.5 29.8333 0.5ZM14.635 24.865C13.92 25.58 12.765 25.58 12.05 24.865L5.46833 18.2833C4.75333 17.5683 4.75333 16.4133 5.46833 15.6983C6.18333 14.9833 7.33833 14.9833 8.05333 15.6983L13.3333 20.9783L25.9467 8.365C26.6617 7.65 27.8167 7.65 28.5317 8.365C29.2467 9.08 29.2467 10.235 28.5317 10.95L14.635 24.865Z"
      fill={color}
    />
  </svg>
);

export default FilledCheckmarkIcon;

<svg
  width="34"
  height="34"
  viewBox="0 0 34 34"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
></svg>;
